"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var chroma_js_1 = __importDefault(require("chroma-js"));
function opacify(color, alpha) {
    /**
     * Set the alpha of a color. Its range for the amount is between 0 and 1.
     *
     * @param {string} color - any string that represents a color (ex: "#f00" or "rgb(255, 0, 0)")
     * @param {number} amount - any positive number
     */
    if (color === 'transparent') {
        return color;
    }
    return (0, chroma_js_1.default)(color).alpha(alpha).css();
}
exports.default = opacify;
